import React from 'react';
import { Box, Skeleton } from '@mui/material';

const ContentSectionSkeleton: React.FC = () => {
    return (
        <Box>
            <Box sx={{ maxWidth: '768px', margin: '0 auto', px: 2 }}>
                <Skeleton variant="text" width="100%" height={20} sx={{ mb: 1 }} />
                <Skeleton variant="text" width="100%" height={20} sx={{ mb: 1 }} />
                <Skeleton variant="text" width="90%" height={20} sx={{ mb: 2 }} />
                <Skeleton variant="text" width="100%" height={20} sx={{ mb: 1 }} />
                <Skeleton variant="text" width="100%" height={20} sx={{ mb: 1 }} />
                <Skeleton variant="text" width="85%" height={20} sx={{ mb: 2 }} />
                <Skeleton variant="rectangular" width="100%" height={300} sx={{ mb: 2, borderRadius: 1 }} />
                <Skeleton variant="text" width="100%" height={20} sx={{ mb: 1 }} />
                <Skeleton variant="text" width="100%" height={20} sx={{ mb: 1 }} />
                <Skeleton variant="text" width="95%" height={20} />
            </Box>
        </Box>
    );
};

export { ContentSectionSkeleton };

